export default "__VITE_ASSET__92777181__"